import { render } from "./DashboardBar1.vue?vue&type=template&id=79b01cec&scoped=true"
import script from "./DashboardBar1.vue?vue&type=script&lang=js"
export * from "./DashboardBar1.vue?vue&type=script&lang=js"

import "./DashboardBar1.vue?vue&type=style&index=0&id=79b01cec&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b01cec"]])

export default __exports__